import styled from 'styled-components/';
import Button from '@mui/material/Button';
import AppCSS from '../../../utils/styled';
import { DefaultModalComponents } from '../../ProjectModal/utils';

export const Components = {
  ...DefaultModalComponents,
  ModalContainer: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    padding-top: 8px;
  `,
  ModalBodyContainer: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
  `,
  ModalTitle: styled.span`
    ${AppCSS.fonts.h4};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  ModalQuestion: styled.div`
    ${AppCSS.fonts.label14Regular};
    color: ${AppCSS.colors.black};
  `,
  ModalButtonsContainer: styled.div`
    width: 100%;
    gap: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
  PrimaryButton: styled(AppCSS.buttonStyles.PrimaryButtonStyle)``,
  TertiaryButton: styled(AppCSS.buttonStyles.TertiaryButtonStyle)``,
  Subtitle: styled.span`
    ${AppCSS.fonts.label10Regular};
    color: ${AppCSS.colors.blues.middle};
  `,
  ModalContentWrapper: styled.div`
    gap: 8px;
  `,
};
